import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

export interface CalendarSyncMappingEntry {
  deviceEventId: string
  /** KeepTouch event updatedAt at last write — used to detect changes. */
  updatedAt: string
  /** Event start (ISO) — used for window-bounded deletion. */
  startDateTime: string
}

interface CalendarSyncState {
  enabled: boolean
  calendarId: string | null
  mapping: Record<string, CalendarSyncMappingEntry>
  setEnabled: (enabled: boolean) => void
  setCalendarId: (calendarId: string | null) => void
  upsertMapping: (keepTouchEventId: string, entry: CalendarSyncMappingEntry) => void
  removeMapping: (keepTouchEventId: string) => void
}

export const useCalendarSyncStore = create<CalendarSyncState>()(
  persist(
    (set) => ({
      enabled: false,
      calendarId: null,
      mapping: {},
      setEnabled: (enabled) => set({ enabled }),
      setCalendarId: (calendarId) => set({ calendarId }),
      upsertMapping: (keepTouchEventId, entry) =>
        set((s) => ({ mapping: { ...s.mapping, [keepTouchEventId]: entry } })),
      removeMapping: (keepTouchEventId) =>
        set((s) => {
          const next = { ...s.mapping }
          delete next[keepTouchEventId]
          return { mapping: next }
        }),
    }),
    { name: 'useCalendarSyncStore', storage: createJSONStorage(() => AsyncStorage) },
  ),
)
